module.exports = __webpack_public_path__ + "static/media/signup.80c0aa6f.png";